<template>
    <div class="ekip-upload" data-test="upload">
        <div v-show="showProgress" class="progress w-100 h-100">
            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :style="{width:`${progress}%`}"
                :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100">
            </div>
        </div>
        <Dropzone
            :id="id"
            :options="options"
            @vdropzone-file-added="handleAdded"
            @vdropzone-success="handleSuccess"
            @vdropzone-error="handleError"
            @vdropzone-total-upload-progress="handleProgress"
            ref="dropzone"
        />
        <div class="position-relative">
            <div class="input-group" @click="handleControlClick">
                <span class="form-control text-truncate" :class="{'is-invalid': hasError}" data-test="upload-form-control">
                    {{ file.name }}
                </span>
                <div class="input-group-append">
                    <div class="form-control d-flex p-0">
                        <button type="button" class="btn btn-sm bg-secondary text-white border-0 m-1">Parcourir...</button>
                    </div>
                </div>
            </div>
        </div>

        <input type="hidden" :name="name" :value="localValue" data-test="upload-input">
        <input type="hidden" :name="`${name}_title`" :value="file.name">

        <div class="invalid-feedback" :class="{'d-block': hasError}">
            <slot v-if="!errorMessage" name="error"></slot>
            <template v-else>
                {{ errorMessage }}
            </template>
        </div>
    </div>
</template>

<script>
    import Dropzone from 'vue2-dropzone';
    import { getCsrfToken } from "../../util/csrf-token";

    export default {
        components: {
            Dropzone
        },
        props: {
            id:String,
            url:String,
            name:String,
            // accept: String,
            value: String,
            fileName: {
                type: String,
                default:''
            }
        },

        data() {
            return {
                accept:'',
                file: { name:this.fileName },
                localValue: this.value,
                errorMessage: '',
                progress: -1
            }
        },

        computed: {
            pending() {
                return this.progress >= 0;
            },
            showProgress() {
                return this.pending;
            },
            hasError() {
                return !!this.errorMessage;
            },
            options() {
                return {
                    url: this.url,
                    headers: {
                        'X-CSRF-TOKEN': getCsrfToken(),
                    },
                    acceptedFiles: this.accept,
                }
            },
        },

        methods: {
            handleControlClick() {
                this.$refs.dropzone.dropzone.hiddenFileInput.click();
            },
            handleAdded(file) {
                this.file = file;
                this.errorMessage='';
                this.localValue='';
            },
            handleProgress(progress) {
                this.progress = progress;
            },
            handleError(file, response) {
                this.$refs.dropzone.removeAllFiles();
                if(typeof response === 'string') {
                    this.errorMessage = response;
                }
                else {
                    let { errors: { file:[msg] } } = response;
                    this.errorMessage = msg;
                    this.endFile();
                }
            },
            handleSuccess(file, response) {
                this.localValue = response.name;
                this.endFile();
            },
            endFile() {
                this.progress = -1;
            },
        },

        mounted() {
            if(this.$slots.error && this.$slots.error[0]) {
                let { elm } = this.$slots.error[0];
                this.errorMessage = elm.innerText || elm.textContent;
            }
        }
    }
</script>